import React from 'react';

if (process.env.NODE_ENV === 'development') {
  // devDependency — ถ้าไม่ได้ติดตั้ง (เช่น npm install แบบ production) ให้ข้ามไป ไม่ทำให้แอปล่ม
  try {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React, {
      trackAllPureComponents: true,
    });
  } catch (e) {
    console.warn('why-did-you-render not installed — skipped');
  }
}
